import React from "react";
import { Modal, ModalBody } from "reactstrap";
import CRFViewStudyScreening from "./CRFViewStudyScreening";
import { CRFScreeningModalProps } from "../helper/studyscreening.constant";

const CRFScreeningModal: React.FC<CRFScreeningModalProps> = ({
    isOpen,
    toggle,
    selectedCrf,
    onClose,
    onSave,
    isPending,
    readonly,
    parentBreadcrumbs,
}) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            backdrop="static"
            size="xl"
            className="crf-fullscreen-modal"
        >
            <ModalBody className="p-0">
                {selectedCrf && (
                    <CRFViewStudyScreening
                        crf={selectedCrf}
                        onClose={onClose}
                        onSave={onSave}
                        isLoading={isPending}
                        readonly={readonly}
                        parentBreadcrumbs={parentBreadcrumbs}
                    />
                )}
            </ModalBody>
        </Modal>
    );
};

export default CRFScreeningModal;